<div class="text-lg font-semibold border-bottom-2 border-cyan-500 mb-2">Persönliche Angaben</div>
{{ contactData.title }} {{ contactData.firstName }} {{ contactData.lastName }}<br />
{{ streetName }} {{ streetNumber }}<br />
{{ postalCode }} {{ city }}<br />
<br />
E-Mail: {{ contactData.email }}<br />
Telefon: {{ contactData.phoneNumber }}<br />
Geburtstag: {{ contactData.birthDate | date }}
